import {
  ActionType,
  IDefaultSettingResponse,
  IDefaultSettingPayload,
} from "models/setting/default";

export const setDefaultSettingAction = (payload: IDefaultSettingPayload) => {
  return {
    type: ActionType.DEFAULT_SETTING,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.DEFAULT_SETTING_ERROR,
    payload,
  };
};

export const handleSuccessAction = (payload: IDefaultSettingResponse) => {
  return {
    type: ActionType.DEFAULT_SETTING_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.DEFAULT_SETTING_RESET,
  };
};
